import { useState } from 'react';
import { Ban } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { PcmpRejectedAtStage } from '../../types/pcmpProposal.types';
import { PcmpAdminRejectDialog } from './PcmpAdminRejectDialog';

interface PcmpAdminRejectButtonProps {
  proposalId: number;
  refNo: string;
  canReject: boolean;
  stage: PcmpRejectedAtStage | null;
}

/** Admin Reject and its dialog, from the API's canAdminReject. */
export function PcmpAdminRejectButton({
  proposalId,
  refNo,
  canReject,
  stage,
}: PcmpAdminRejectButtonProps) {
  const [open, setOpen] = useState(false);

  // An open dialog outlives the capability: a 409 refresh (it was held
  // meanwhile) clears canReject, and its message must stay readable.
  if (!canReject && !open) return null;

  return (
    <>
      {canReject ? (
        <Button
          type="button"
          size="sm"
          variant="outline"
          onClick={() => setOpen(true)}
          className="gap-1.5 text-destructive hover:text-destructive"
        >
          <Ban className="size-3.5" />
          Admin Reject
        </Button>
      ) : null}
      {/* Mounted only while open, so it starts empty. */}
      {open ? (
        <PcmpAdminRejectDialog
          proposalId={proposalId}
          refNo={refNo}
          stage={stage}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
}
